// Version : 0.0.1
// Author : VISHNU
// LastEdit : SATHISH VISHNU
//Last ADD : paylod changes'
// MODFIED DATA : 30-07-2025
import CompanyActionTypes from './company.type';

/*************** Create Company Start ******************/
export const addCompanyDetailsStart = (addData: any) => ({
	type: CompanyActionTypes.ADD_COMPANY_DETAILS_START,
	payload: addData,
});

export const addCompanyDetailsSuccess = (successData: any) => ({
	type: CompanyActionTypes.ADD_COMPANY_DETAILS_SUCCESS,
	payload: successData,
});

export const addCompanyDetailsFailure = (failureData: any) => ({
	type: CompanyActionTypes.ADD_COMPANY_DETAILS_FAILURE,
	payload: failureData,
});

export const addCompanyDetailsResponseReset = () => ({
	type: CompanyActionTypes.ADD_COMPANY_DETAILS_RESPONSE_RESET,
});

export const addCompanyDetailsResponseChanged = () => ({
	type: CompanyActionTypes.ADD_COMPANY_DETAILS_RESPONSE_CHANGED,
});
/*************** Create Company End ******************/

/*************** Get All Company List Start ******************/
export const getCompanyListStart = (getData: any) => ({
	type: CompanyActionTypes.GET_COMPANY_LIST_START,
	payload: getData,
});

export const getCompanyListSuccess = (successData: any) => ({
	type: CompanyActionTypes.GET_COMPANY_LIST_SUCCESS,
	payload: successData,
});

export const getCompanyListFailure = (failureData: any) => ({
	type: CompanyActionTypes.GET_COMPANY_LIST_FAILURE,
	payload: failureData,
});

export const getCompanyListResponseReset = () => ({
	type: CompanyActionTypes.GET_COMPANY_LIST_RESPONSE_RESET,
});

export const getCompanyListResponseChanged = () => ({
	type: CompanyActionTypes.GET_COMPANY_LIST_RESPONSE_CHANGED,
});
/*************** Get All Company List End ******************/

/*************** Fetch Company Details Start ******************/
export const fetchCompanyDetailsStart = (fetchData: any) => ({
	type: CompanyActionTypes.FETCH_COMPANY_DETAILS_START,
	payload: fetchData,
});

export const fetchCompanyDetailsSuccess = (successData: any) => ({
	type: CompanyActionTypes.FETCH_COMPANY_DETAILS_SUCCESS,
	payload: successData,
});

export const fetchCompanyDetailsFailure = (failureData: any) => ({
	type: CompanyActionTypes.FETCH_COMPANY_DETAILS_FAILURE,
	payload: failureData,
});

export const fetchCompanyDetailsResponseReset = () => ({
	type: CompanyActionTypes.FETCH_COMPANY_DETAILS_RESPONSE_RESET,
});

export const fetchCompanyDetailsResponseChanged = () => ({
	type: CompanyActionTypes.FETCH_COMPANY_DETAILS_RESPONSE_CHANGED,
});
/*************** Fetch Company Details End ******************/

/*************** Update Company Details Start ******************/
export const updateCompanyDetailsStart = (updateData: any) => ({
	type: CompanyActionTypes.UPDATE_COMPANY_DETAILS_START,
	payload: updateData,
});

export const updateCompanyDetailsSuccess = (successData: any) => ({
	type: CompanyActionTypes.UPDATE_COMPANY_DETAILS_SUCCESS,
	payload: successData,
});

export const updateCompanyDetailsFailure = (failureData: any) => ({
	type: CompanyActionTypes.UPDATE_COMPANY_DETAILS_FAILURE,
	payload: failureData,
});

export const updateCompanyDetailsResponseReset = () => ({
	type: CompanyActionTypes.UPDATE_COMPANY_DETAILS_RESPONSE_RESET,
});

export const updateCompanyDetailsResponseChanged = () => ({
	type: CompanyActionTypes.UPDATE_COMPANY_DETAILS_RESPONSE_CHANGED,
});
/*************** Update Company Details End ******************/

/*************** Delete Company Details Start ******************/
export const deleteCompanyDetailsStart = (deleteData: any) => ({
	type: CompanyActionTypes.DELETE_COMPANY_DETAILS_START,
	payload: deleteData,
});

export const deleteCompanyDetailsSuccess = (successData: any) => ({
	type: CompanyActionTypes.DELETE_COMPANY_DETAILS_SUCCESS,
	payload: successData,
});

export const deleteCompanyDetailsFailure = (failureData: any) => ({
	type: CompanyActionTypes.DELETE_COMPANY_DETAILS_FAILURE,
	payload: failureData,
});

export const deleteCompanyDetailsResponseReset = () => ({
	type: CompanyActionTypes.DELETE_COMPANY_DETAILS_RESPONSE_RESET,
});

export const deleteCompanyDetailsResponseChanged = () => ({
	type: CompanyActionTypes.DELETE_COMPANY_DETAILS_RESPONSE_CHANGED,
});
/*************** Delete Company Details End ******************/

/*********************** FINANCE COMPANY ******************************/

/*************** Create Company For Finance Start ******************/
export const createCompanyStart = (addData: any) => ({
	type: CompanyActionTypes.CREATE_COMPANY_START,
	payload: addData,
});

export const createCompanySuccess = (successData: any) => ({
	type: CompanyActionTypes.CREATE_COMPANY_SUCCESS,
	payload: successData,
});

export const createCompanyFailure = (failureData: any) => ({
	type: CompanyActionTypes.CREATE_COMPANY_FAILURE,
	payload: failureData,
});

export const createCompanyResponseReset = () => ({
	type: CompanyActionTypes.CREATE_COMPANY_RESPONSE_RESET,
});

export const createCompanyResponseChanged = () => ({
	type: CompanyActionTypes.CREATE_COMPANY_RESPONSE_CHANGED,
});
/*************** Create Company For Finance End ******************/

/*************** Update Company For Finance Start ******************/
export const updateCompanyStart = (updateData: any) => ({
	type: CompanyActionTypes.UPDATE_COMPANY_START,
	payload: updateData,
});

export const updateCompanySuccess = (successData: any) => ({
	type: CompanyActionTypes.UPDATE_COMPANY_SUCCESS,
	payload: successData,
});

export const updateCompanyFailure = (failureData: any) => ({
	type: CompanyActionTypes.UPDATE_COMPANY_FAILURE,
	payload: failureData,
});

export const updateCompanyResponseReset = () => ({
	type: CompanyActionTypes.UPDATE_COMPANY_RESPONSE_RESET,
});

export const updateCompanyResponseChanged = () => ({
	type: CompanyActionTypes.UPDATE_COMPANY_RESPONSE_CHANGED,
});
/*************** Update Company For Finance End ******************/

/*************** Delete Company For Finance Start ******************/
export const deleteCompanyStart = (deleteData: any) => ({
	type: CompanyActionTypes.DELETE_COMPANY_START,
	payload: deleteData,
});

export const deleteCompanySuccess = (successData: any) => ({
	type: CompanyActionTypes.DELETE_COMPANY_SUCCESS,
	payload: successData,
});

export const deleteCompanyFailure = (failureData: any) => ({
	type: CompanyActionTypes.DELETE_COMPANY_FAILURE,
	payload: failureData,
});

export const deleteCompanyResponseReset = () => ({
	type: CompanyActionTypes.DELETE_COMPANY_RESPONSE_RESET,
});

export const deleteCompanyResponseChanged = () => ({
	type: CompanyActionTypes.DELETE_COMPANY_RESPONSE_CHANGED,
});
/*************** Delete Company For Finance End ******************/

/** ***************** ADD INSTANCE DETAILS START *********************** */
export const addInstanceDetailsStart = (addData: any) => ({
	type: CompanyActionTypes.ADD_INSTANCE_DETAILS_START,
	payload: addData,
});

export const addInstanceDetailsSuccess = (successData: any) => ({
	type: CompanyActionTypes.ADD_INSTANCE_DETAILS_SUCCESS,
	payload: successData,
});

export const addInstanceDetailsFailure = (failureData: any) => ({
	type: CompanyActionTypes.ADD_INSTANCE_DETAILS_FAILURE,
	payload: failureData,
});

export const addInstanceDetailsResponseResetStart = () => ({
	type: CompanyActionTypes.ADD_INSTANCE_DETAILS_RESPONSE_RESET,
});

export const addInstanceDetailsResponseChanged = () => ({
	type: CompanyActionTypes.ADD_INSTANCE_DETAILS_RESPONSE_CHANGED,
});
/** ***************** ADD INSTANCE DETAILS END *********************** */

/** ***************** ADD ALTER TABLE  DETAILS START *********************** */
export const addAlterTableDetailsStart = (addData: any) => ({
	type: CompanyActionTypes.ADD_ALTER_TABLE_START,
	payload: addData,
});

export const addAlterTableDetailsSuccess = (successData: any) => ({
	type: CompanyActionTypes.ADD_ALTER_TABLE_SUCCESS,
	payload: successData,
});

export const addAlterTableDetailsFailure = (failureData: any) => ({
	type: CompanyActionTypes.ADD_ALTER_TABLE_FAILURE,
	payload: failureData,
});

export const addAlterTableDetailsResponseReset = () => ({
	type: CompanyActionTypes.ADD_ALTER_TABLE_RESPONSE_RESET,
});

export const addAlterTableDetailsResponseChanged = () => ({
	type: CompanyActionTypes.ADD_ALTER_TABLE_RESPONSE_CHANGED,
});
/** ***************** ADD ALTER TABLE  DETAILS END *********************** */

/** ***************** FETCH EXIST DATA START *********************** */
export const fetchExistDataStart = (fetchData: any) => ({
	type: CompanyActionTypes.FETCH_EXIST_DATA_START,
	payload: fetchData,
});

export const fetchExistDataSuccess = (successData: any) => ({
	type: CompanyActionTypes.FETCH_EXIST_DATA_SUCCESS,
	payload: successData,
});

export const fetchExistDataFailure = (failureData: any) => ({
	type: CompanyActionTypes.FETCH_EXIST_DATA_FAILURE,
	payload: failureData,
});

export const fetchExistDataResponseReset = () => ({
	type: CompanyActionTypes.FETCH_EXIST_DATA_RESPONSE_RESET,
});

export const fetchExistDataResponseChanged = () => ({
	type: CompanyActionTypes.FETCH_EXIST_DATA_RESPONSE_CHANGED,
});
/** ***************** FETCH EXIST DATA END *********************** */
